import { useEffect, useState } from 'react';

interface ReturnValue {
  isMobile: boolean;
}

const useResizeLayout = (): ReturnValue => {
  const [width, setWidth] = useState(window.innerWidth);
  const handleWindowSizeChange = (): void => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  return { isMobile };
};

export default useResizeLayout;
